export const FEEDBACK_SUCCESS_TITLE = 'Заявка успешно отправлена';
export const FEEDBACK_SUCCESS_TEXT = 'В течение 15 минут наш менеджер перезвонит вам для уточнения вопросов';

export const CREATE_ORDER_SUCCESS_TEXT = 'В течение 15 минут наш менеджер перезвонит вам для подтверждения заказа';

export const NOTIFICATION_PRODUCT_ADDED_TO_CART = 'Товар добавлен в корзину';
export const NOTIFICATION_PRODUCT_REMOVE_TO_CART = 'Товар удален из корзины';

export const DEFAULT_ERROR_TEXT = 'Ошибка, попробуйте позже';

export const NO_ACCESS_TOKEN = 'no access token';

export const TITLE_METADATA = 'Интернет-магазин мебели для ванной комнаты OLEVARO';
export const DESCRIPTION_METADATA =
  'на сайте интернет-магазина OLEVARO. Большой выбор мебели для ванной комнаты по выгодным ценам в нашем каталоге. У нас вы найдете широкий ассортимент тумб, шкафов, LED-зеркал с подробным описанием и характеристиками.';
